import { useMemo } from "react";
import { useTranslations } from '../../../utils/translations';

export const useTwitterShareURL = (doneeName: string, givingLink: string) => {
    const { post } = useTranslations('socialMediaGiving.twitter.page', {
        post: ['text'],
    });

    const twitterShareURL = useMemo(() => {
        const postContent = post.text.replace('{DONEE_NAME}', doneeName);

        return (
            `https://twitter.com/intent/tweet?text=${postContent} ` +
            encodeURI(givingLink)
        );
    }, [doneeName, post.text, givingLink]);

    return twitterShareURL;
};